import { defineMessages } from 'react-intl';

export default defineMessages({
  'sagas_address_type' : {
    'id' : 'sagas.msg.address_type',
    'defaultMessage' : 'Address type was saved'
  },
  'sagas_brand' : {
    'id' : 'sagas.msg.brand',
    'defaultMessage' : 'Brand was saved'
  },
});